import dayjs from 'dayjs';

export const formatStringDateForDayCalendarComponent = (date: string) => {
  const formatedString = date.replace(/T|Z/g, ' ').trim();
  return new Date(dayjs(formatedString).toISOString());
};
